import React, { Component } from "react";
import * as Http from "../../http";
import { ProgressBar, MenuItem, DropdownButton, Table } from "react-bootstrap";
import * as Business from "../../utils/business";
import { ErrorCode } from "../../const";
import { Field, reduxForm } from "redux-form";
import renderField from "components/FormInputs/renderField";
import { FileExtension } from "../../const";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

const chunkSize = 1048576 * 3;
let lstInterval = [];

function clearGetBatchUploadInterval(reportName) {
  lstInterval.forEach((id) => {
    clearInterval(id);
    console.warn(`${reportName} | Received state: STOP`);
  });
}

function convertReportName(reportName) {
  return `ICAAP_${reportName}`;
}

const dicSingleConsol = {
  single: "SINGLE",
  consol: "CONSOL",
};

class UploadFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progressValue: 0,
      errorCode: null,

      singleConsol: "single",
      fileExtension: FileExtension.XLSX,
      isMultipleFile: false,
      fileAccept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
      reportName: "",
      reportDate: null,
      noFileVal: "No file chosen...",
      classFileUpload: "file-upload",

      totalFiles: 0,
      listFileNameSelected: [],
      dicFileToBeUpload: {},
      isUploadOnly: false,
      isUploadAndMerge: false,
      isCalculateOnly: false,
      isUploadOnlySuccessful: false,
      isUploadAndMergeSuccessful: false,
    };
    this.setFileExtensionSelected = this.setFileExtensionSelected.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
    this.onUploadFile = this.onUploadFile.bind(this);
    this.onUploadFileAndMergeData = this.onUploadFileAndMergeData.bind(this);
    this.onUploadChunkFile = this.onUploadChunkFile.bind(this);
    this.onUploadChunkFileComplete = this.onUploadChunkFileComplete.bind(this);
    this.onGetBatchUploadingResponse =
      this.onGetBatchUploadingResponse.bind(this);

    this.handleUploadFileResponse = this.handleUploadFileResponse.bind(this);
    this.renderProgress = this.renderProgress.bind(this);
    this.renderUploadOnlySuccessful =
      this.renderUploadOnlySuccessful.bind(this);
  }

  onChangeFile = (e) => {
    const target = e.target;
    const filename = target ? target.value : "";
    let classFileUpload = "file-upload";
    let noFileVal = "No file chosen...";

    if (/^\s*$/.test(filename)) {
      classFileUpload = "file-upload";
      noFileVal = "No file chosen...";
    } else {
      classFileUpload = "file-upload active";
      noFileVal = filename.replace("C:\\fakepath\\", "");
    }

    this.setState({ classFileUpload, noFileVal }, () => {
      const dicFileToBeUpload = {};
      const listFileNameSelected = [];
      let totalFiles = 0;
      if (target.files) {
        for (let index in target.files) {
          if (new RegExp(/^\d+$/).test(index)) {
            const file = target.files[index];
            const totalCount =
              file.size % chunkSize === 0
                ? file.size / chunkSize
                : Math.floor(file.size / chunkSize) + 1; // Total count of chunks will have been upload to finish the file
            const fileID = uuidv4() + "." + file.name.split(".").pop();
            dicFileToBeUpload[file.name] = {
              counter: 1,
              fileName: file.name,
              fileToBeUpload: file,
              beginingOfTheChunk: 0,
              endOfTheChunk: chunkSize,
              fileGuid: fileID,
              fileSize: file.size,
              chunkCount: totalCount > 0 ? totalCount : 1,
              isUploaded: false,
            };
            listFileNameSelected.push(file.name);
            totalFiles++;
          }
        }
        if (totalFiles > 1) {
          noFileVal = `${totalFiles} files chosen`;
        }
      }
      this.setState({
        listFileNameSelected,
        dicFileToBeUpload,
        noFileVal,
        totalFiles,
      });
    });
  };

  getCurrentFileUploadingInfo = () => {
    const { fileUploading, dicFileToBeUpload } = this.state;
    const fileUploadingInfo = dicFileToBeUpload.hasOwnProperty(fileUploading)
      ? dicFileToBeUpload[fileUploading]
      : {};
    return fileUploadingInfo;
  };

  updateDicFileToBeUpload = (fileName, data, cb) => {
    const dicFileToBeUpload = this.state.dicFileToBeUpload;
    if (dicFileToBeUpload.hasOwnProperty(fileName)) {
      dicFileToBeUpload[fileName] = { ...dicFileToBeUpload[fileName], data };
    }
    this.setState({ dicFileToBeUpload }, () => {
      cb && cb();
    });
  };

  onUploadChunkFile = () => {
    try {
      let fileUploadingInfo = this.getCurrentFileUploadingInfo();
      const fileUploading = this.state.fileUploading;
      const currentCounter = fileUploadingInfo.counter;
      fileUploadingInfo["counter"] = currentCounter + 1;

      this.updateDicFileToBeUpload(
        fileUploading,
        fileUploadingInfo,
        async () => {
          fileUploadingInfo = this.getCurrentFileUploadingInfo();
          const {
            fileGuid,
            chunkCount,
            fileToBeUpload,
            beginingOfTheChunk,
            endOfTheChunk,
          } = fileUploadingInfo;

          if (currentCounter <= chunkCount) {
            const chunk = fileToBeUpload.slice(
              beginingOfTheChunk,
              endOfTheChunk
            );

            Http.uploadChuckFile(chunk, {
              id: currentCounter,
              fileName: fileGuid,
            }).then(async (response) => {
              const isSuccess = response ? response.Success : false;
              if (isSuccess) {
                fileUploadingInfo["beginingOfTheChunk"] = endOfTheChunk;
                fileUploadingInfo["endOfTheChunk"] = endOfTheChunk + chunkSize;
                this.updateDicFileToBeUpload(
                  fileUploading,
                  fileUploadingInfo,
                  async () => {
                    fileUploadingInfo = this.getCurrentFileUploadingInfo();
                    if (currentCounter == chunkCount) {
                      fileUploadingInfo["isUploaded"] = true;
                      this.updateDicFileToBeUpload(
                        fileUploading,
                        fileUploadingInfo,
                        async () => {
                          let isAllFilesUploaded = true;
                          for (let fileName in this.state.dicFileToBeUpload) {
                            if (
                              this.state.dicFileToBeUpload[fileName][
                                "isUploaded"
                              ] === false
                            ) {
                              isAllFilesUploaded = false;
                              break;
                            }
                          }
                          console.warn(
                            `The file upload is completed. Counter: ${currentCounter}, OriginFile: ${fileToBeUpload.name}, FileId: ${fileGuid}`
                          );
                          await this.onUploadChunkFileComplete(
                            isAllFilesUploaded
                          );
                        }
                      );
                    } else {
                      var percentage =
                        this.state.progressValue /
                          Object.keys(this.state.dicFileToBeUpload).length +
                        (currentCounter / chunkCount) * 100;
                      if (percentage > 99) percentage = 100;
                      console.warn(
                        `'The file is uploading. Counter ${currentCounter}, OriginFile: ${fileToBeUpload.name}, FileId: ${fileGuid}`
                      );
                      this.setState({ progressValue: percentage }, () => {
                        this.onUploadChunkFile();
                      });
                    }
                  }
                );
              } else {
                console.error("Error Occurred:", response.ErrorCode);
                await this.handleUploadFileResponse(response);
              }
            });
          }
        }
      );
    } catch (error) {
      console.error(error);
    }
  };

  onUploadChunkFileComplete = async (isAllFilesUploaded) => {
    const {
      reportName,
      reportDate,
      fileExtension,
      isUploadAndMerge,
      isUploadOnly,
      isUploadAndMergeSuccessful,
      isCalculateOnly,
      singleConsol,
    } = this.state;
    let fileUploadingInfo = this.getCurrentFileUploadingInfo();
    const { fileToBeUpload, fileGuid } = fileUploadingInfo;

    Http.uploadChuckFileComplete(
      fileGuid,
      {
        originFileName: fileToBeUpload ? fileToBeUpload.name : fileGuid,
        fileGuid: fileGuid,
        reportName: convertReportName(reportName),
        reportDate: reportDate,
        isAllFilesUploaded,
        fileExtension,
        singleConsol,

        isUploadOnly: isUploadOnly.toString(),
        isUploadAndMerge: isUploadAndMerge.toString(),
        isCalculateOnly: isCalculateOnly.toString(),
      },
      true
    ).then((res) => {
      if (res && res.ErrorCode == ErrorCode.PendingUpload) {
        let { listFileNameSelected } = this.state;
        const fileUploading = listFileNameSelected.shift();
        this.setState({ fileUploading, listFileNameSelected }, () => {
          this.onUploadChunkFile();
        });
      } else {
        this.setState({ progressValue: 100 }, () => {
          this.handleUploadFileResponse(res);
          this.onGetBatchUploadingResponse();
        });
      }
    });
  };

  onUploadFile = () => {
    this.setState({ hasResult: false, progressValue: 5 }, () => {
      if (this.state.isCalculateOnly) {
        this.onUploadChunkFileComplete(true);
        return;
      }
      let { listFileNameSelected } = this.state;
      const fileUploading = listFileNameSelected.shift();
      this.setState({ fileUploading, listFileNameSelected }, () => {
        this.onUploadChunkFile();
      });
    });
  };

  onGetBatchUploadingResponse = () => {
    const intervalId = setInterval(() => {
      console.warn(
        `${convertReportName(
          this.state.reportName
        )} | Request to get batch response`
      );
      Http.getBatchResult(
        this.state.reportDate,
        convertReportName(this.state.reportName)
      ).then((res) => {
        if (res) {
          if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
            console.warn(
              `${convertReportName(
                this.state.reportName
              )} | Received state: PendingBatchProcessing`
            );
          } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
            clearGetBatchUploadInterval(
              convertReportName(this.state.reportName)
            );
            console.warn(
              `${convertReportName(
                this.state.reportName
              )} | Received state: BatchEmpty`
            );
          } else {
            console.warn(
              `${convertReportName(
                this.state.reportName
              )} | Received state: Success`
            );
            this.handleUploadFileResponse(res);
          }
        }
      });
    }, 3000);
    lstInterval.push(intervalId);
  };

  onValidate = () => {
    if (!this.state.fileExtension) {
      Business.showAlert({
        title: "Error",
        content: "You must choose a file extension before upload.",
      });
      return false;
    }
    if (this.state.totalFiles === 0) {
      Business.showAlert({
        title: "Error",
        content: "You must select least 1 file.",
      });
      return false;
    }

    if (!this.state.reportName) {
      Business.showAlert({
        title: "Error",
        content: "You must enter value for Report Name.",
      });
      return false;
    }

    if (!new RegExp("^[A-Za-z0-9_]+$").test(this.state.reportName)) {
      Business.showAlert({
        title: "Error",
        content: "Report Name: allow only (a-z, A-Z, 0-9, _)",
      });
      return false;
    }

    if (!this.state.reportDate) {
      Business.showAlert({
        title: "Error",
        content: "You must enter value for Report Date.",
      });
      return false;
    }
    return true;
  };

  onUploadFileOnly = async () => {
    const isCalculating = await Business.hasBatchCalculating();
    if (isCalculating) {
      Business.showAlert({
        title: "Error",
        content: "The system is busy. Please try again in a few moments.",
      });
      return;
    }
    if (this.onValidate()) {
      this.setState({ isUploadOnly: true }, this.onUploadFile);
    }
  };

  onUploadFileAndMergeData = () => {
    if (this.onValidate()) {
      this.setState({ isUploadAndMerge: true }, this.onUploadFile);
    }
  };

  setFileExtensionSelected = (fileExtension) => {
    if (this.state.fileExtension != fileExtension) {
      this.setState({
        fileExtension,
        isMultipleFile: fileExtension != FileExtension.XLSX,
        fileAccept: `.${fileExtension}, ${this.fileAccept}`,
        file: null,
      });
    }
  };

  handleUploadFileResponse = (res) => {
    const errorCode = res ? res.ErrorCode : null;
    this.setState({ errorCode });
    if (res && res.ErrorCode !== ErrorCode.PendingBatchProcessing) {
      clearGetBatchUploadInterval(convertReportName(this.state.reportName));
    }
    if (res && res.Success) {
      if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        // console.warn('Received state: PendingBatchProcessing');
      } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
        // console.warn('Received state: BatchEmpty');
      } else if (res.ErrorCode === ErrorCode.UploadOnlySuccessful) {
        this.setState({
          progressValue: 0,
          isUploadOnly: false,
          isUploadAndMerge: false,
          isCalculateOnly: false,
          isUploadOnlySuccessful: true,
          isUploadAndMergeSuccessful: false,
        });
      } else if (res.ErrorCode === ErrorCode.UploadAndMergeSuccessful) {
        this.setState({
          progressValue: 0,
          isUploadOnly: false,
          isUploadAndMerge: false,
          isCalculateOnly: false,
          isUploadOnlySuccessful: false,
          isUploadAndMergeSuccessful: true,
        });
      } else {
        const data = res.Data || {};
        this.setState({
          singleResult: data.SingleResult,
          consolResult: data.ConsolResult,
          progressValue: 0,
          hasResult: true,
          isUploadOnly: false,
          isUploadAndMerge: false,
          isCalculateOnly: false,
          isUploadOnlySuccessful: false,
          isUploadAndMergeSuccessful: false,
        });
      }
    } else {
      if (res) {
        switch (res.ErrorCode) {
          case ErrorCode.PermissionDenie:
            Business.showAlert({
              title: "Error",
              content: "You are not permission",
            });
            break;
          case ErrorCode.Empty:
            Business.showAlert({
              title: "Error",
              content: "File is empty",
            });
            break;
          case ErrorCode.Exist:
            Business.showAlert({
              title: "Error",
              content: "Name already exists in the system",
            });
            break;
          case ErrorCode.DataInvalid:
            Business.showAlert({
              title: "Error",
              content: res.Data,
            });
            break;
          case ErrorCode.UnknowError:
            Business.showAlert({
              title: "Error",
              content: res.Data || "System Error",
            });
            break;
          default:
            break;
        }
      } else {
        Business.showAlert({
          title: "Error",
          content: "Unknow Error",
        });
      }
      this.setState({
        progressValue: 0,
        isUploadOnly: false,
        isUploadAndMerge: false,
        isCalculateOnly: false,
        isUploadOnlySuccessful: false,
        isUploadAndMergeSuccessful: false,
      });
    }
  };

  renderPendingBatchProcessing = () => {
    return (
      <div>
        <div className="header">
          <h4
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "50px",
            }}
            className="title"
          >
            The system is processing the uploaded file. Please wait...
          </h4>
        </div>
      </div>
    );
  };

  renderProgress = () => {
    return (
      <div>
        <div className="row">
          <div className="col-xs-12">
            <div className="content text-center">
              <ProgressBar
                striped
                now={this.state.progressValue}
                label={`Upload ${this.state.progressValue.toFixed(3)}%`}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderUploadOnlySuccessful = () => {
    return (
      <div>
        <div className="header">
          <h4
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "50px",
            }}
            className="title"
          >
            Upload successful
          </h4>
        </div>
      </div>
    );
  };

  renderUploadAndMegeSuccessful = () => {
    return (
      <div>
        <div className="header">
          <h4
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "50px",
            }}
            className="title"
          >
            Upload and merge data successfully
          </h4>
        </div>
      </div>
    );
  };

  handleSelectSingleConsolMethod = (eventKey, event) => {
    this.setState({ singleConsol: eventKey });
  };

  onDownloadSample = () => {
    return Http.downloadSampleFile(
      `${Business.COMPONENT.ICAAP.toUpperCase()}.zip`,
      "sample",
      Business.COMPONENT.ICAAP
    );
  };

  render() {
    return (
      Business.isHasRole([Business.ROLE_DEFINE_MAP.ICAAP_UPLOAD_FILES]) && (
        <div className="card">
          <div className="header" style={{ gap: 16 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                color: "#757575",
                fontSize: 16,
              }}
            >
              <p style={{ marginBottom: 0 }}>ICAAP</p>
              <p style={{ marginBottom: 0 }}>/</p>
              <p style={{ color: "#BF6A02", marginBottom: 0 }}>Upload file</p>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <h4 className="title" style={{ fontSize: 20 }}>
                Upload file
              </h4>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 16,
                alignItems: "center",
              }}
            >
              <div
                style={{
                  flex: 1,
                  border: "1px solid #BF6A02",
                  backgroundColor: "#FFFBEB",
                  borderRadius: 8,
                  padding: "12px 16px",
                  fontSize: 16,
                  lineHeight: "22px",
                }}
              >
                <p style={{ marginBottom: 0 }}>
                  Reports must follow the format in this template file.
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "12px 14px",
                  cursor: "pointer",
                }}
                onClick={() => this.onDownloadSample()}
              >
                <i
                  style={{ fontSize: 16, color: "#2140F1" }}
                  className="pe-7s-download"
                ></i>
                <p
                  className="title"
                  style={{
                    color: "#2140F1",
                    fontFamily: "Open Sans",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "16px",
                    textAlign: "right",
                    marginBottom: 0,
                  }}
                  onClick={() => this.onDownloadSample()}
                >
                  Download sample file
                </p>
              </div>
            </div>
          </div>
          <div style={{ height: 6 }} />
          <div
            className="content table-responsive table-full-width"
            style={{ paddingBottom: "0px !important" }}
          >
            <form>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 16,
                }}
              >
                <div className="form-group" style={{ flex: 1 }}>
                  <label
                    htmlFor="exampleInputEmail1"
                    style={{ fontSize: 16, lineHeight: "22px" }}
                  >
                    Report Name
                  </label>
                  <span style={{ fontSize: 16, color: "#C00F0C" }}> *</span>
                  <input
                    type="text"
                    className="form-control"
                    id="reportname"
                    onChange={(event) => {
                      this.setState({ reportName: event.target.value });
                    }}
                    required={true}
                    style={{
                      border: "1px solid #D9D9D9",
                      backgroundColor: "#FFFFFF",
                      borderRadius: 8,
                      height: 44,
                    }}
                  />
                </div>
                <div className="form-group" style={{ flex: 1 }}>
                  <label
                    htmlFor="exampleInputEmail12"
                    style={{ fontSize: 16, lineHeight: "22px" }}
                  >
                    Report Date
                  </label>
                  <span style={{ fontSize: 16, color: "#C00F0C" }}> *</span>
                  <input
                    type="date"
                    className="form-control"
                    id="reportDate"
                    min="2010-01-01"
                    max={moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD")}
                    placeholder="MM/DD/YYYY"
                    required={true}
                    value={this.state.reportDate}
                    onChange={(event) => {
                      this.setState({ reportDate: event.target.value });
                    }}
                    style={{
                      border: "1px solid #D9D9D9",
                      backgroundColor: "#FFFFFF",
                      borderRadius: 8,
                      height: 44,
                    }}
                  />
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 32 }}>
                <p
                  style={{ marginBottom: 15, fontSize: 16, lineHeight: "22px" }}
                >
                  File format:
                </p>
                <div className="form-group row">
                  <div
                    className="col-md-6 checkbox-group"
                    style={{ display: "flex" }}
                  >
                    {["XLSX", "CSV"].map((fileExtension, index) => (
                      <div
                        key={index}
                        style={{ display: "inline-block", marginRight: "30px" }}
                        onClick={() =>
                          this.setFileExtensionSelected(fileExtension)
                        }
                      >
                        <Field
                          name="radioGroup"
                          type="radio"
                          label={`.${fileExtension}`}
                          value={fileExtension}
                          checked={this.state.fileExtension === fileExtension}
                          component={renderField}
                        />
                      </div>
                    ))}
                  </div>
                  <div
                    className="col-md-6"
                    style={{ textAlign: "right", padding: "10px" }}
                  >
                    {/* <label>Ngày 31/12/2022 đang tồn tại bản ghi Chờ phê duyệt</label> */}
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label
                  htmlFor="exampleFormControlFile1"
                  style={{ fontSize: 16, lineHeight: "22px" }}
                >
                  Upload data file
                </label>
                <span style={{ fontSize: 16, color: "#C00F0C" }}> *</span>
                <div
                  className={this.state.classFileUpload}
                  style={{ display: "flex", gap: 16 }}
                >
                  <div
                    className="file-select-name"
                    id="noFile"
                    style={{
                      flex: 1,
                      padding: "14px 16px",
                      fontSize: 16,
                      lineHeight: 1,
                      border: "1px solid #D9D9D9",
                      borderRadius: 8,
                      textAlign: "left",
                      color:
                        this.state.noFileVal === "No file chosen..."
                          ? "#B3B3B3"
                          : "#1E1E1E",
                    }}
                  >
                    {this.state.noFileVal}
                  </div>
                  <div
                    className="file-select"
                    style={{ height: 44, border: "none" }}
                  >
                    <div
                      className="file-select-button"
                      id="fileName"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "10px 12px",
                        fontSize: 16,
                        lineHeight: "22px",
                        cursor:
                          this.state.progressValue > 0
                            ? "not-allowed"
                            : "pointer",
                        border: "1px solid #767676",
                        backgroundColor: "#E3E3E3",
                        borderRadius: 8,
                        color: "#1E1E1E",
                        height: 44,
                      }}
                    >
                      <i
                        style={{
                          fontSize: 16,
                          color: "#1E1E1E",
                          marginRight: 8,
                        }}
                        className="pe-7s-upload"
                      ></i>
                      Choose File
                    </div>
                    <input
                      type="file"
                      multiple={this.state.isMultipleFile}
                      name="chooseFile"
                      id="chooseFile"
                      disabled={this.state.progressValue > 0}
                      accept={this.state.fileAccept}
                      onChange={(e) => this.onChangeFile(e)}
                    />
                  </div>
                </div>
              </div>
            </form>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 16,
                marginTop: 17,
              }}
            >
              <button
                type="submit"
                disabled={this.state.progressValue > 0}
                className="btn btn-primary"
                style={{
                  backgroundColor: "#2C2C2C",
                  borderColor: "#2C2C2C",
                  borderRadius: "8px",
                  fontSize: 16,
                  lineHeight: 1,
                  color: "#F5F5F5",
                  height: 44,
                }}
                onClick={() => this.onUploadFileOnly()}
              >
                Upload
              </button>
            </div>
          </div>

          <div style={{ height: 30 }} />
          {this.state.progressValue > 0 && this.renderProgress()}
          {this.state.isUploadOnlySuccessful &&
            this.state.errorCode !== ErrorCode.PendingBatchProcessing &&
            this.renderUploadOnlySuccessful()}
          {this.state.isUploadAndMergeSuccessful &&
            this.state.errorCode !== ErrorCode.PendingBatchProcessing &&
            this.renderUploadAndMegeSuccessful()}
          {this.state.errorCode === ErrorCode.PendingBatchProcessing &&
            this.renderPendingBatchProcessing()}
        </div>
      )
    );
  }
}

export default reduxForm({
  form: "UploadFile",
})(UploadFile);



// WEBPACK FOOTER //
// ./src/pages/ICAAP/UploadFile.js